<!-- Live regions must exist before a toast is added, or screen readers miss the first one -->
<section class="gung-toast-viewport" data-position="bottom-right" aria-live="polite">
  <ng-container *ngTemplateOutlet="stack; context: { $implicit: bottomRight }"></ng-container>
</section>
<section class="gung-toast-viewport" data-position="bottom-center" aria-live="polite">
  <ng-container *ngTemplateOutlet="stack; context: { $implicit: bottomCenter }"></ng-container>
</section>

<ng-template #stack let-toasts>
  @for (toast of toasts; track toast.id) {
    <lib-gung-toast
      [toast]="toast"
      [canExpand]="activeIds.includes(toast.id)"
      (hoverChange)="onHover(toast.id, $event)"
      (dismiss)="dismiss(toast.id)"
    ></lib-gung-toast>
  }
</ng-template>
